import React, { type FC } from 'react';

import { ExportsPLUpsell } from '@confluence/change-edition/entry-points/ExportsPLUpsell.tsx';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { ExportShareAsPublicLinkProps } from './ExportShareAsPublicLink.tsx';

interface PublicLinksExportMenuEntryPointProps {
	closeDropdownMenu: () => void;
	contentId: string;
}

export const ExportShareAsPublicLink: LoadableType<ExportShareAsPublicLinkProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExportShareAsPublicLink" */ './ExportShareAsPublicLink.tsx'
			)
		).ExportShareAsPublicLink,
});

export const PublicLinksExportMenuEntryPoint: FC<PublicLinksExportMenuEntryPointProps> = ({
	closeDropdownMenu,
	contentId,
}) => (
	<>
		<ExportsPLUpsell onClick={closeDropdownMenu} />
		<ExportShareAsPublicLink contentId={contentId} onClick={closeDropdownMenu} />
	</>
);
